<template>
    <div class="container">
      <br />
      <b-card title="Confirmación de compra" >
        <b-card-text>
          <b-container class="bv-example-row">
            <b-row>
              <b-col>
                <div>
                  <div v-if="esEnvioRM"><b-badge variant="success">Envío Región Metropolitana</b-badge></div>
                  <div v-if="esEnvioStarken"><b-badge variant="success">Envío por Starken</b-badge></div>
                  <div v-if="esSegundoPedido"><b-badge variant="success">Segundo Pedido</b-badge></div>
                  <div v-if="esRetiroDomicilio"><b-badge variant="success">Retiro a Domicilio</b-badge></div>
                  <div v-if="esSegundoPedido">
                    Nro Pedido: {{usuario.nroPedido != '' ? usuario.nroPedido : '-' }}<br />
                  </div>
                    Nombre: {{usuario.nombre}} {{usuario.apellido}}<br />
                    Email: {{usuario.email}}<br />
                    Teléfono: {{usuario.telefono}}<br />
                  <div v-if="esEnvioRM || esEnvioStarken">
                    Dirección: {{usuario.direccion}}<br />
                    Comuna: {{usuario.comuna}}<br />
                    Región: {{usuario.region}}<br />
                  </div>
                    Monto total de Compra: {{totalCompra}}<br />
                  <div v-if="esEnvioStarken">
                    Rut: {{usuario.rut != '' ? usuario.rut : '-' }}<br />
                  </div>
                  <div v-if="esEnvioStarken || esEnvioRM">
                    Referencia: {{usuario.referencia != '' ? usuario.referencia : '-' }}<br />
                  </div>
                  <div v-if="esRetiroDomicilio || esSegundoPedido">
                    Comentario: {{usuario.referencia != '' ? usuario.referencia : '-' }}<br />
                  </div>
                </div>
              </b-col>
              <b-col>
                <b>Detalle pedido</b><br />
                <ul>
                  <li v-for="(item, index) in productos" :key="index">
                    {{item.cantidad}} x {{item.nombre}} (${{item.precio}})
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-container>
        </b-card-text>
        <b-button-group class="btn float-right">
          <b-button @click="continuar()" variant="primary" :disabled="btnDisabled">
            <b-spinner v-if="btnDisabled" small></b-spinner>
            <span> Confirmar</span>
          </b-button>
          <b-button @click="cancelar()" variant="outline-danger">Cancelar</b-button>
        </b-button-group>
      </b-card>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'

const optChile = { style: 'currency', currency: 'CLP' }
const numFormatPeso = new Intl.NumberFormat('es-CL', optChile)

export default {
  name: 'PasoConfirmacion',
  data () {
    return {
      usuario: {},
      productos: {},
      totalCompra: '',
      esEnvioRM: false,
      esEnvioStarken: false,
      esSegundoPedido: false,
      esRetiroDomicilio: false,
      btnDisabled: false
    }
  },
  methods: {
    ...mapMutations(['comprar']),
    continuar () {
      this.btnDisabled = true
      this.comprar(this.datosSolicitante)
      this.btnDisabled = false
    },
    cancelar () {
      this.$router.push({ name: 'FormularioUsuario' })
    }
  },
  beforeMount () {
    this.$store.state.modoCompra = true
  },
  beforeDestroy () {
    this.$store.state.modoCompra = false
  },
  mounted () {
    this.usuario = this.datosSolicitante.usuario
    this.productos = this.datosSolicitante.productos
    this.totalCompra = numFormatPeso.format(this.datosSolicitante.pedido.total)
    this.esEnvioRM = false
    this.esEnvioStarken = false
    this.esSegundoPedido = false
    this.esRetiroDomicilio = false
    if (this.carro.envio.id === 1) {
      this.usuario.region = 'Región Metropolitana Urbana'
      this.esEnvioRM = true
    } else if (this.carro.envio.id === 2) {
      this.esEnvioStarken = true
    } else if (this.carro.envio.id === 3) {
      this.esSegundoPedido = true
    } else if (this.carro.envio.id === 4) {
      this.esRetiroDomicilio = true
    }
  },
  computed: {
    ...mapState({
      datosSolicitante: state => state.datosSolicitante,
      carro: state => state.carro
    })
  }
}
</script>
